// Updated App.js
import {Routes, Route, Navigate} from 'react-router-dom';
import './App.css';
import TopNav from "./components/TopNav";
import MasterProducts from "./components/MasterProducts";
import LwinReferences from "./components/LwinReferences";
import DataSources from "./components/DataSources";
import Alerts from "./components/Alerts";
import AlertRules from "./components/AlertRules";
import BbrAccount from "./components/BbrAccount";
import React from "react";

function App() {

    const [refreshKey, setRefreshKey] = React.useState(0);

    const handleRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleImportComplete = () => {
        // Refresh data when import completes
        handleRefresh();
    };

    console.log('Environment variables:', {
        NODE_ENV: process.env.NODE_ENV,
        REACT_APP_API_URL: process.env.REACT_APP_API_URL,
        ALL_REACT_APP_VARS: Object.keys(process.env).filter(key => key.startsWith('REACT_APP_'))
    });

    return (
        <div className="App">
            <TopNav/>
            <Routes>
                <Route path="/" element={<Navigate to="/master-products" replace />} />
                <Route path="/master-products" element={
                    <MasterProducts refreshKey={refreshKey} onRefresh={handleRefresh}/>
                }/>
                <Route path="/alerts" element={<Alerts />} />
                <Route path="/alert-rules" element={<AlertRules />} />
                <Route path="/data-sources" element={
                    <DataSources refreshKey={refreshKey} onRefresh={handleRefresh} onImportComplete={handleImportComplete}/>
                }/>
                <Route path="/lwin" element={
                    <LwinReferences refreshKey={refreshKey} onRefresh={handleRefresh}/>
                }/>
                <Route path="/bbr-account" element={<BbrAccount />} />
            </Routes>
        </div>
    );
}

export default App;